module.exports = __webpack_public_path__ + "img/ThreeJS.69514c7e.png";